import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import { Toaster } from './components/ui/sonner';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Tools from './pages/Tools';
import AIMentor from './pages/AIMentor';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Signup from './pages/Signup';
import About from './pages/About';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import Admin from './pages/Admin';
import NuRataAsta from './pages/NuRataAsta';
import MagneticTransformation from './pages/MagneticTransformation';
import FisaClient from './pages/FisaClient';
import '@/App.css';

function App() {
  const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <HelmetProvider>
        <LanguageProvider>
          <AuthProvider>
            <BrowserRouter>
            <Routes>
              {/* Standalone landing page - no navbar/footer */}
              <Route path="/nu-rata-asta" element={<NuRataAsta />} />
              
              {/* Private password-protected page - no navbar/footer */}
              <Route path="/magneticTransformation" element={<MagneticTransformation />} />
              
              {/* Printable client form - no navbar/footer */}
              <Route path="/fisa-client" element={<FisaClient />} />
              
              {/* Regular pages with navbar/footer */}
              <Route path="/*" element={
                <div className="App min-h-screen bg-white">
                  <Navbar />
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/products/:slug" element={<ProductDetail />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog/:slug" element={<BlogPost />} />
                    <Route path="/tools" element={<Tools />} />
                    <Route path="/ai-money-mentor" element={<AIMentor />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/signup" element={<Signup />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/legal/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/legal/terms" element={<Terms />} />
                    <Route path="/admin" element={<Admin />} />
                  </Routes>
                  <Footer />
                  <Toaster position="top-right" richColors />
                  <CookieConsent />
                </div>
              } />
            </Routes>
            </BrowserRouter>
          </AuthProvider>
        </LanguageProvider>
      </HelmetProvider>
    </GoogleOAuthProvider>
  );
}

export default App;